export const services = [
  {
    title: "API Development",
    desc: "Development of API manufacturing routes, optimizing yield, purity and scalability.",
  },
  {
    title: "Process Development",
    desc: "Robust process workflows for repeatable production outcomes and reliable scale-up.",
  },
  {
    title: "Custom Synthesis",
    desc: "Tailored synthesis support for unique molecules and customer specifications.",
  },
  {
    title: "Contract Manufacturing",
    desc: "Production readiness with QC checkpoints, documentation and operational excellence.",
  },
  {
    title: "Regulatory Support",
    desc: "Documentation support and compliance-ready datasets to simplify submissions.",
  },
  {
    title: "Technical Consultancy",
    desc: "Expert guidance bridging R&D to manufacturing with practical, quality-first execution.",
  },
]

